export default __webpack_public_path__ + "static/media/dominic.a330d0f9.png";